import { restRequest } from "vrcore-dashboard/dist/utilities";

export const GET_REPORT = restRequest("VRCORE.BLOCK_VEHICLE.GET_REPORT");
export const SET_REPORT = restRequest("VRCORE.BLOCK_VEHICLE.SET_REPORT");
